// Core Modules
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  // Injectors
  private readonly title = inject(Title);

  // Private Members
  private readonly DEFAULT_TITLE = 'Admin Portal';

  override updateTitle(routerState: RouterStateSnapshot): void {
    const titles: string[] = [];

    // Collect titles from parent to child, skipping empty routes
    let route: ActivatedRouteSnapshot | null = routerState.root;
    while (route) {
      if (route.title && route.title.trim()) {
        const titleStr = route.title as string;
        if (!titles.includes(titleStr)) {
          titles.push(titleStr);
        }
      }
      route = route.firstChild;
    }

    // Set title: Page titles first, then app name at the end
    const finalTitle = titles.length ? `${titles.join(' | ')} - ${this.DEFAULT_TITLE}` : this.DEFAULT_TITLE;
    this.title.setTitle(finalTitle);
  }
}
